export default (name: String) => {
  const lowerCase = name.toLowerCase().split(" ");
  const titleCase = lowerCase.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return titleCase.join(" ");
};
